'use client';

import { signIn } from 'next-auth/react';
import { useState } from 'react';
import { Mail, Lock, Loader2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
export default function LoginForm({
  showButton = true
}: {
  showButton?: boolean;
}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await signIn('credentials', {
        email,
        password,
        redirect: false
      });
      if (res?.ok) {
        window.location.href = '/dashboard';
      } else {
        setError('Invalid email or password. Please try again.');
      }
    } catch {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return <form onSubmit={handleSubmit} className="space-y-6 w-full">
      {/* Email Field */}
      <div className="space-y-2">
        <label htmlFor="email" className="text-sm font-medium text-slate-700">
          Email Address
        </label>
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
          <Input id="email" type="email" placeholder="Enter your email" value={email} onChange={e_0 => setEmail(e_0.target.value)} className="pl-10 h-12 border-slate-200 focus:border-blue-500 focus:ring-blue-500 bg-white" required disabled={loading} />
        </div>
      </div>
      <div className="space-y-2">
        <label htmlFor="password" className="text-sm font-medium text-slate-700">
          Password
        </label>
        <div className="relative">
          <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
          <Input id="password" type="password" placeholder="Enter your password" value={password} onChange={e_1 => setPassword(e_1.target.value)} className="pl-10 h-12 border-slate-200 focus:border-blue-500 focus:ring-blue-500 bg-white" required disabled={loading} />
        </div>
      </div>
      {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
          {error}
        </div>}
      {showButton && <Button type="submit" disabled={loading} className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed" size="lg">
          {loading ? <>
              <Loader2 className="w-5 h-5 mr-2 animate-spin" />
              Signing in...
            </> : 'Sign In'}
        </Button>}
      <div className="text-center pt-4 border-t border-slate-200">
        <p className="text-xs text-slate-500">
          Protected by secure authentication
        </p>
      </div>
    </form>;
}